/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpagefilterstatusall4Inputs */

const en_ticketpagefilterstatusall4 = /** @type {(inputs: Ticketpagefilterstatusall4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Any status`)
};

const de_ticketpagefilterstatusall4 = /** @type {(inputs: Ticketpagefilterstatusall4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeder Status`)
};

/**
* | output |
* | --- |
* | "Any status" |
*
* @param {Ticketpagefilterstatusall4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpagefilterstatusall4 = /** @type {((inputs?: Ticketpagefilterstatusall4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpagefilterstatusall4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpagefilterstatusall4(inputs)
	return de_ticketpagefilterstatusall4(inputs)
});
export { ticketpagefilterstatusall4 as "ticketPageFilterStatusAll" }